import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.css';
import 'styles/tailwind.css';
import './i18n';

ReactDOM.render(
	<React.Suspense fallback="">
		<App />
	</React.Suspense>,
	document.getElementById('root'),
);
